<template>
    <div>
        <link
            href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap"
            rel="stylesheet">
        <page-navigate></page-navigate>

        <div class="BuzzHeader text-center">
            <img src="@/assets/image/trading_central/section1Bg.jpg" alt="" class="BuzzBg pc">
            <div class="BuzzHeaderContainer">
                <img src="@/assets/image/trading_central/pageLogo.png" alt="" class="BuzzHeaderLogo">
                <h1 class="super_large-72_bold md-title-32_bold">定制化分析引擎</h1>
                <h2 class="subtitle-20_regular md-body-14_regular">EBC与Trading Central携手合作，提供专业的市场分析工具，帮助客户深入了解市场、发现交易机会并优化交易策略</h2>
                <img src="@/assets/image/trading_central/section1Model.png" alt="" class="pc BuzzModel">
                <img src="@/assets/image/trading_central/section1ModelM.png" alt="" class="mobile BuzzModel">
                <div class="shadowContainer">
                    <a :href="signupUrl" target="_blank" class="BuzzHeaderBtn primary-default_large">
                        <span>解锁完整版</span>
                        <span class="iconfont icon-right"></span>
                    </a>
                    <div class="BuzzHeaderFooter footnote-regular_12 text-center">*本页面的信息不构成EBC、Trading
                        Central或其内容供应商对金融工具投资的建议或推荐。EBC、Trading Central及其内容供应商不对因使用此信息导致的任何损失或损害承担责任</div>
                </div>
            </div>
        </div>
        <div class="BuzzFloatTab body-16_regular md-footnote-regular_12 flex items-center justify-center">
            <a class="tabWord active" data-target="mBuzz">市场热力图</a>
            <div class="tabSplit"></div>
            <a class="tabWord" data-target="fIdeas">可视化策略</a>
            <div class="tabSplit"></div>
            <a class="tabWord" data-target="analystViews">分析师观点</a>
            <div class="tabSplit"></div>
            <a class="tabWord" data-target="economicCalendar">财经日历</a>
            <div class="tabSplit"></div>
            <a class="tabWord" data-target="techIndicator">技术指标</a>
            <div class="tabSplit"></div>
            <a class="tabWord" data-target="MPTech">教学视频</a>
        </div>
        <div class="mBuzz section-block" id="mBuzz">
            <div class="contentBox">
                <div class="title title-48_bold md-title-24_bold scroll-fade-up text-center">市场热力图</div>
                <div class="sub-title subtitle-20_regular md-footnote-regular_12 scroll-fade-up text-center">
                    TC Market Buzz®（市场热力图）利用全球舆情数据智能分析工具，从纷繁的信息中筛选出真正有价值的信息
                </div>
            </div>
            <div class="content">
                <iframe class="scrollbar-container mBuzzIframe" :src="TCIframe2"></iframe>
            </div>
        </div>
        <div class="mBuzz section-block" id="fIdeas" style="padding-top: 60rem;">
            <div class="contentBox">
                <div class="title title-48_bold md-title-24_bold scroll-fade-up text-center">可视化策略</div>
                <div class="sub-title subtitle-20_regular md-footnote-regular_12 scroll-fade-up text-center">
                    Featured Ideas®（可视化策略）依托自适应图表引擎，自动解析技术形态并精准标注，多维呈现市场趋势与潜在机遇。
                </div>
            </div>
            <div class="content">
                <iframe class="scrollbar-container mBuzzIframe" :src="TCIframe3"></iframe>
            </div>
            <div class="mbuzzContentShadow">
                <a :href="signupUrl" target="_blank" class="primary-default_large">
                    <span class="word11">登录解锁完整版</span>
                    <span class="iconfont icon-right"></span>
                </a>
            </div>
        </div>
        <div class="analystViews section-block" id="analystViews">
            <div class="contentBox">
                <div class="title title-48_bold md-title-24_bold scroll-fade-up text-center word7">分析师观点</div>
                <div class="sub-title subtitle-20_regular md-footnote-regular_12 scroll-fade-up text-center word20">
                    通过清晰的趋势线展示简明易行的交易计划，并在整个交易时段持续发布，帮助您发现新的交易机会。
                </div>
            </div>
            <div class="content scroll-fade-up">
                <div id="app">
                    <div class="nav-list">
                        <div class="nav-item" :class="{ 'active': item.isActive }" @click="e => handleNavChange(item, e)"
                            v-for="(item, index) in navList" :key="index">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="contentBox">
                        <div class="data-content">
                            <div class="data-left scrollbar-container">
                                <div v-for="(item, index) in dataList" :key="index">
                                    <div class="data-item" :class="{ 'isSelected': item.isSelected }"
                                        @click="handlerSelect(item, index)">
                                        <div class="flex-between">
                                            <div class="data-name">
                                                {{ item.analysis.content.header.name['#text'] }}
                                            </div>
                                            <div class="data-time">
                                                {{ item.hover }}(UTC+2)
                                                <!-- |{{item.analysis.content.header.hour['#text'] }} -->
                                            </div>
                                        </div>
                                        <div class="data-title"
                                            :class="[{ 'up': item.opinion > 0 }, { 'down': item.opinion < 0 }]">
                                            <span class="iconfont icon-up"></span>
                                            {{ item.analysis.content.story.title['#text'] }}
                                        </div>
                                        <div class="data-summary">
                                            {{ item.analysis.content.story.summary['#text'] }}
                                        </div>
                                    </div>
                                    <transition name="fade">
                                        <div v-if="currentItem.analysis && item.isSelected && mobileShow"
                                            class="mobile-item">
                                            <img style="margin: 0 auto"
                                                :src="currentItem.analysis.content.header.media['#text']" alt="" />
                                            <div class="info-list">
                                                <div class="info-paragraph"
                                                    v-for="(item, index) in currentItem.analysis.content.story.paragraph">
                                                    <template v-if="item['@attributes']">
                                                        <div>{{ item['#text'] }}</div>
                                                    </template>
                                                    <template v-else>
                                                        <div v-for="(str, i) in getOptionsStr(item['#text'])"
                                                            :class="{ 'label': i == 0 }">
                                                            {{ str }}
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="info-paragraph word18" style="font-style: italic">
                                                    星号数代表支撑位和阻力位的强度。
                                                </div>
                                            </div>
                                            <div class="flex-right">
                                                <div class="btn body-14_medium" @click="closeMobileItem">
                                                    <span class="word14">收起</span>
                                                    <span class="iconfont icon-right"></span>

                                                </div>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                            <div class="data-right scrollbar-container">
                                <div v-if="currentItem.analysis">
                                    <img style="margin: 0 auto"
                                        :src="currentItem.analysis.content.header.media['#text']" alt="" />
                                    <div class="info-list">
                                        <div class="info-paragraph"
                                            v-for="(item, index) in currentItem.analysis.content.story.paragraph">
                                            <template v-if="item['@attributes']">
                                                <div>{{ item['#text'] }}</div>
                                            </template>
                                            <template v-else>
                                                <div v-for="(str, i) in getOptionsStr(item['#text'])"
                                                    :class="{ 'label': i == 0 }">
                                                    {{ str }}
                                                </div>
                                            </template>
                                        </div>
                                        <div class="info-paragraph word18" style="font-style: italic">
                                            星号数代表支撑位和阻力位的强度。
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="loading-box" v-show="loading">
                            <span class="iconfont icon-loading"></span>
                        </div>
                    </div>

                </div>
            </div>
            <div class="appContentShadow">
                <a :href="signupUrl" target="_blank" class="primary-default_large">
                    <span class="word11">登录解锁完整版</span>
                    <span class="iconfont icon-right"></span>
                </a>
            </div>
        </div>
        <div class="economicCalendar text-center section-block" id="economicCalendar">
            <div class="contentBox">
                <div class="title title-48_bold md-title-24_bold scroll-fade-up word8">财经日历解析</div>
                <div class="sub-title subtitle-20_regular md-footnote-regular_12 scroll-fade-up word22">
                    提供38个国家/地区的实时宏观经济数据，帮助交易者监控、预测和应对潜在的市场波动。
                </div>
                <div class="content">
                    <iframe id="TCIframe" class="scrollbar-container" :src="TCIframe"></iframe>
                </div>
            </div>
        </div>

        <div class="techIndicator section-block" id="techIndicator">
            <div class="contentBox">
                <div class="techIndicatorTitle title-48_bold md-title-24_bold text-center scroll-fade-up word9">
                    Alpha-MT4/MT5
                    技术指标</div>
                <div
                    class="techIndicatorDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word24">
                    通过三个简明的创新指标展示市场情绪，帮助交易者做出决策，找到潜在的进入/退出点
                </div>
                <div class="techIndicatorIntro flex justify-between items-center scroll-fade-up">
                    <div class="wordList">
                        <div class="wordItem">
                            <div class="topTitle subtitle-20_medium md-body-16_medium word25">技术观点</div>
                            <div class="bottomDesc content-16_regular md-footnote-regular_12 word26">
                                通过技术分析结果，为每张图表提供首选方向和目标点位
                            </div>
                        </div>
                        <div class="wordItem">
                            <div class="topTitle subtitle-20_medium md-body-16_medium word27">自适应K线图</div>
                            <div class="bottomDesc content-16_regular md-footnote-regular_12 word28">支持16种与决策相关的K线图形模式
                            </div>
                        </div>
                        <div class="wordItem">
                            <div class="topTitle subtitle-20_medium md-body-16_medium word29">自适应趋异指标(ADC)</div>
                            <div class="bottomDesc content-16_regular md-footnote-regular_12 word30">
                                长短进/出信号、快慢价格指标、初始/平滑信号线和快慢震荡器</div>
                        </div>
                    </div>
                    <img src="@/assets/image/trading_central/techIndicatorModel.png" alt="" class="model">
                </div>
                <a :href="signupUrl" target="_blank" class="primary-default_large techIndicatorBtn scroll-fade-up">
                    <img src="@/assets/image/trading_central/download.png" alt="" class="icon">
                    <span class="word31">获取指标</span>
                </a>
            </div>
        </div>

        <div class="MPTech section-block" id="MPTech">
            <div class="contentBox">
                <div class="MPTechTitle title-48_bold md-title-24_bold text-center scroll-fade-up word32">Martin Pring
                    教学视频
                </div>
                <div class="MPTechDesc subtitle-20_regular md-footnote-regular_12 text-center scroll-fade-up word33">
                    通过Martin
                    Pring的视频课程，学习技术分析基础，掌握趋势线和移动平均线等技巧，提升交易水平。
                </div>
                <div class="MPTechContent flex justify-between items-center scroll-fade-up">
                    <div class="left">
                        <img src="@/assets/image/trading_central/MPTechModel.png" class="pc MPTechModel" alt="" />
                        <img src="@/assets/image/trading_central/MPTechModelM.png" class="mobile MPTechModel" alt="" />
                    </div>
                    <div class="MPTechAdvanList">
                        <div class="MPTechAdvan">
                            <div class="MPTechAdvanInfo">
                                <p class="MPTechAdvanTitle subtitle-20_medium md-body-16_medium word34">灵活的学习模式：</p>
                                <p class="MPTechAdvanDesc content-16_regular md-footnote-regular_12 word35">
                                    可以自由安排学习进度，通过丰富的内容和工具，轻松掌握投资技巧。
                                </p>
                            </div>
                        </div>
                        <div class="MPTechAdvan">
                            <div class="MPTechAdvanInfo">
                                <p class="MPTechAdvanTitle subtitle-20_medium md-body-16_medium word36">广泛的内容覆盖：</p>
                                <p class="MPTechAdvanDesc content-16_regular md-footnote-regular_12 word37">
                                    从初级到高级，全面课程内容满足不同水平用户的需求，系统提升投资技能。
                                </p>
                            </div>
                        </div>
                        <div class="MPTechAdvan">
                            <div class="MPTechAdvanInfo">
                                <p class="MPTechAdvanTitle subtitle-20_medium md-body-16_medium word38">互动学习体验：</p>
                                <p class="MPTechAdvanDesc content-16_regular md-footnote-regular_12 word39">
                                    包含术语表和自我评估等互动工具，检测学习进展，增强理解和记忆效果。
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <a :href="signupUrl" target="_blank" rel="nofollow"
                    class="MPTechBtn primary-default_large scroll-fade-up word40" type="blank">了解更多
                </a>
            </div>

        </div>
        <page-footer></page-footer>
    </div>

</template>
<script>
import moment from 'moment';
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from 'vuex';
// XML解析函数
function parseElement(element) {
    let obj = {};
    if (element.nodeType === 1) {
        // Element
        if (element.attributes.length > 0) {
            obj["@attributes"] = {};
            for (let j = 0; j < element.attributes.length; j++) {
                let attribute = element.attributes.item(j);
                obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
            }
        }
    } else if (element.nodeType === 3) {
        // Text
        obj = element.nodeValue;
    }

    if (element.hasChildNodes()) {
        for (let i = 0; i < element.childNodes.length; i++) {
            let item = element.childNodes.item(i);
            let nodeName = item.nodeName;
            if (typeof obj[nodeName] === "undefined") {
                obj[nodeName] = parseElement(item);
            } else {
                if (typeof obj[nodeName].push === "undefined") {
                    let old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(parseElement(item));
            }
        }
    }
    return obj;
}


export default {
    mixins: [fadeAnimate],

    data() {
        return {
            message: "Hello Vue!",
            navList: [
                { name: this.$i18n.t('TradingCentral.衍生品'), value: "forex", isActive: true },
                { name: this.$i18n.t('TradingCentral.指数'), value: "index", isActive: false },
                { name: this.$i18n.t('TradingCentral.商品'), value: "commodities", isActive: false },
                { name: "美股", value: "stock", isActive: false },
            ],
            currentNav: "forex",
            currentItem: {},
            dataList: [],
            loading: false,
            mobileShow: true,
            TCIframe: "",
            TCIframe2: '',
            TCIframe3: ''
        }
    },
    created() {
        this.getData();
        this.getUrl();
        this.getUrl2();
        this.getUrl3();
    },
    mounted() {
        this.sethadowBottom();
        this.initPage();
    },
    filters: {
        // 去除中文冒号
        removeColon(str) {
            if (str[str.length - 1] == "：") {
                return str.substring(0, str.length - 2);
            }
            return str;
        },
    },
    methods: {
        initPage() {
            function initStickyScrollSpy({ navSelector, itemSelector, sectionSelector, offset = 0 }) {

                const navContainer = document.querySelector(navSelector);
                const navItems = document.querySelectorAll(itemSelector);
                const sections = document.querySelectorAll(sectionSelector);

                // 标记点击状态，防止 Scroll 监听器在点击跳转时产生冲突
                let isClickScrolling = false;
                let clickTimer = null;

                // 1. 移除所有 active 类
                function removeAllActive() {
                    navItems.forEach(item => item.classList.remove('active'));
                }

                // 2. 设置 Active 状态 (含横向滚动逻辑)
                function setActive(targetId) {
                    // 如果当前已经是这个ID激活，就不重复操作DOM，提升性能
                    const currentActive = document.querySelector(`${itemSelector}.active`);
                    if (currentActive && currentActive.getAttribute('data-target') === targetId) return;

                    removeAllActive();

                    const activeItem = Array.from(navItems).find(
                        item => item.getAttribute('data-target') === targetId
                    );

                    if (activeItem) {
                        activeItem.classList.add('active');

                        // 移动端横向滚动处理
                        if (window.matchMedia("(max-width: 996px)").matches) {
                            const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                            const leftPad = 32 * rem; // 根据你的CSS调整
                            const wrapper = document.querySelector(navSelector);

                            // 平滑滚动 TAB 栏
                            wrapper.scrollTo({
                                left: activeItem.offsetLeft - leftPad,
                                behavior: 'smooth'
                            });
                        }
                    }
                }

                // 3. 核心：滚动监听处理函数
                function handleScroll() {
                    if (isClickScrolling) return;

                    let currentSectionId = "";

                    // 核心算法：倒序遍历或正序遍历寻找最符合条件的 Section
                    // 这里使用 forEach 配合判定：找到所有 "top <= offset" 的区块中，位置最靠下的那个

                    /* 原理：
                       当页面滚动时，如果不只一个 Section 的顶部跑到了 offset 上方，
                       我们需要的是 "最后一个" 跑上去的，也就是当前显示在最上面的那个。
                    */

                    sections.forEach(section => {
                        const sectionTop = section.getBoundingClientRect().top;

                        // 这里的 offset + 10 是一个缓冲值，让判定线稍微宽松一点
                        if (sectionTop <= offset + 10) {
                            currentSectionId = section.getAttribute('id');
                        }
                    });

                    // 边界处理：如果页面滚到底部了，强制高亮最后一个
                    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 10) {
                        const lastSection = sections[sections.length - 1];
                        if (lastSection) currentSectionId = lastSection.getAttribute('id');
                    }

                    if (currentSectionId) {
                        setActive(currentSectionId);
                    } else if (window.scrollY < offset) {
                        // 如果滚动条在最顶端且没有区块碰到 offset，可以选择高亮第一个或清空
                        if (sections.length > 0) setActive(sections[0].getAttribute('id'));
                    }
                }

                // 4. 点击事件处理
                navItems.forEach((item) => {
                    item.addEventListener('click', (e) => {
                        e.preventDefault();
                        const targetId = item.getAttribute('data-target');
                        const targetSection = document.getElementById(targetId);

                        if (targetSection) {
                            // 1. 锁住 Scroll 监听
                            isClickScrolling = true;
                            if (clickTimer) clearTimeout(clickTimer);

                            // 2. 立即高亮当前项
                            setActive(targetId);

                            // 3. 计算位置并滚动
                            const elementPosition = targetSection.getBoundingClientRect().top;
                            const offsetPosition = elementPosition + window.pageYOffset - offset;

                            window.scrollTo({
                                top: offsetPosition,
                                behavior: "smooth"
                            });

                            // 4. 解锁 Scroll 监听 (使用 scrollend 事件更稳妥，或者延时)
                            // 简单的延时处理，大约等于滚动动画时长
                            clickTimer = setTimeout(() => {
                                isClickScrolling = false;
                                // 点击滚动结束后，手动触发一次检查，修正可能存在的微小误差
                                handleScroll();
                            }, 800);
                        }
                    });
                });

                // 5. 绑定滚动事件 (添加防抖或节流可以优化性能，但在桌面端 requestAnimationFrame 更好，这里用简单监听即可)
                // 为了性能，建议使用 passive: true
                window.addEventListener('scroll', handleScroll, { passive: true });

                // 初始化时执行一次，防止刷新后不高亮
                handleScroll();
            }
            initStickyScrollSpy({
                navSelector: '.BuzzFloatTab',
                itemSelector: '.tabWord',
                sectionSelector: '.section-block',
                offset: 100
            });
        },
        getUrl() {
            const lang = this.$i18n.t("TradingCentral.lang2");
            const formData = new FormData();
            formData.append('lang', lang);
            fetch('https://ebccfd.com/TradingCentral/EconomicCalendar/', {
                method: 'POST',
                body: formData
            }).then((res) => {
                return res.text()
            }).then((res) => {
                console.log("res", res)
                this.TCIframe = res;
            }).catch(() => {

            })

        },
        getUrl2() {
            const lang = this.$i18n.t("TradingCentral.lang2");
            const formData = new FormData();
            formData.append('lang', lang);
            fetch('https://ebccfd.com/TradingCentral/TCBuzzLogin/', {
                method: 'POST',
                body: formData
            }).then((res) => {
                return res.text()
            }).then((res) => {
                console.log("res", res)
                this.TCIframe2 = res;
            }).catch(() => {

            })

        },
        getUrl3() {
            const lang = this.$i18n.t("TradingCentral.lang2");
            const formData = new FormData();
            formData.append('lang', lang);
            fetch('https://ebccfd.com/TradingCentral/TCFeatured/', {
                method: 'POST',
                body: formData
            }).then((res) => {
                return res.text()
            }).then((res) => {
                console.log("res2", res)
                this.TCIframe3 = res;
            }).catch(() => {

            })

        },
        getOptionsStr(str) {
            let reg1 = /:/;
            let reg2 = /：/;
            if (reg1.test(str)) {
                return str.split(":");
            } else if (reg2.test(str)) {
                return str.split("：");
            } else {
                return [str];
            }
        },
        handleNavChange(item,e) {
            // console.log("item", item, this.navList);
            if (item.value == this.currentNav) {
                return;
            }
            this.navList = this.navList.map((el,idx) => {
                if (el.name == item.name) {
                    el.isActive = true;
                    this.currentNav = item.value;
                    this.getData();
                    if(window.matchMedia("(max-width: 996px)").matches){
                    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                    const leftPad = 32 * rem;
                    const wrapper = document.querySelector(".analystViews #app .nav-list");
                    wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
                }
                } else {
                    el.isActive = false;
                }
                return el;
            });
        },
         getDistToParentBottom(parentDom, childClassName) {
              const child = parentDom.querySelector(`.${childClassName}`);
              if (!child) {
                  console.warn('未找到指定子元素');
                  return 0;
              }
              const parentRect = parentDom.getBoundingClientRect();
              const childRect = child.getBoundingClientRect();
              return parentRect.bottom - childRect.bottom;
        },
          sethadowBottom(){
            if(!window.matchMedia("(max-width: 996px)").matches){
              return
            }
            const mobileEl = document.querySelector('.analystViews .mobile-item')
            if(!this.currentItem.analysis || !mobileEl) {
              document.querySelector('.appContentShadow').style.display = 'none'
            }else{
              const bottomDistance = this.getDistToParentBottom(document.querySelector('.analystViews'),'mobile-item')
              document.querySelector('.appContentShadow').style.display = 'block'
              document.querySelector('.appContentShadow').style.bottom = `${bottomDistance+42}px`
            }
          },
          closeMobileItem(){
            this.mobileShow = false;
            setTimeout(()=>{
              this.sethadowBottom();
            },50)
          },
        handlerSelect(item, index) {
            if (item.id === this.currentItem.id) {
                this.mobileShow = !this.mobileShow;
                 setTimeout(()=>{
              this.sethadowBottom();
            },50)
                return;
            }
            this.mobileShow = true;
            this.dataList = this.dataList.map((el, i) => {
                if (index == i) {
                    el.isSelected = true;
                    this.currentItem = this.createCurrentItem(el);
                } else {
                    el.isSelected = false;
                }
                return el;
            });
            setTimeout(()=>{
              this.sethadowBottom();
            },50)
        },
        getData(pageSize = 10, pageNumber = 1) {
            const token = "%2bmWwS%2bbwWi1BYrke%2fZDrpA%3d%3d";
            const type_product = this.currentNav;
            this.loading = true;
            const lang = this.$i18n.t("TradingCentral.lang");
            fetch(
                `https://feed.tradingcentral.com/ws_ta.asmx/GetFeed?culture=${lang}
              &type_product=${type_product}&product=null&term=null&days=1&last_ta=true
              &pageSize=${pageSize}&pageNumber=${pageNumber}
              &partner=2010&token=${token}`,
                {
                    method: "get",
                }
            )
                .then((response) => response.text())
                .then((response) => {
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(
                        response,
                        "application/xml"
                    );
                    let json = parseElement(xmlDoc.documentElement);
                    if (Array.isArray(json.article)) {

                    } else {
                        json.article = [json.article]
                    }
                    this.dataList = json.article.map((el) => {
                        el.isSelected = false;

                        /*
                        Use <watch> element to know if the Technical Views is bullish or bearish.
                        Values can be 2, 1, -1, -2:
                        2 (rise), 1 (limited rise), 0 (consolidation), -1 (limited decline), -2 (decline)
      
                        **If <term> is “INTRADAY” then check <watch type=“opinionIntraday”>
                        If <term> is “ST” then check <watch type=“opinionST”>
                        If <term> is “MT” then check <watch type=“opinionMT”>
                        */
                        let opinion;
                        if (el.analysis.content.header.term["#text"] == "INTRADAY") {
                            console.log("INTRADAY");
                            el.analysis.content.header.option.watch.map((item) => {
                                if (item["@attributes"].type == "opinionIntraday") {
                                    opinion = item["#text"];
                                }
                            });
                        } else if (el.analysis.content.header.term["#text"] == "ST") {
                            console.log("ST");
                            el.analysis.content.header.option.watch.map((item) => {
                                if (item["@attributes"].type == "opinionST") {
                                    opinion = item["#text"];
                                }
                            });
                        } else if (el.analysis.content.header.term["#text"] == "MT") {
                            console.log("MT");
                            el.analysis.content.header.option.watch.map((item) => {
                                if (item["@attributes"].type == "opinionMT") {
                                    opinion = item["#text"];
                                }
                            });
                        }

                        let hover = moment(
                            el.analysis.content.header.date["#text"].substring(0, 4) +
                            "-" +
                            el.analysis.content.header.date["#text"].substring(4, 6) +
                            "-" +
                            el.analysis.content.header.date["#text"].substring(6) +
                            " " +
                            el.analysis.content.header.hour["#text"]
                        )
                            .add(1, "h")
                            .format("HH:mm");
                        el.id = el["@attributes"].id;
                        el.opinion = opinion;
                        el.hover = hover;
                        return el;
                    });

                    this.currentItem = this.createCurrentItem(this.dataList[0]);
                    this.loading = false;
                    setTimeout(()=>{
                  this.sethadowBottom();
                },50)
                })
                .catch((err) => {
                    this.loading = false;
                    console.log("err", err);
                });
        },
        createCurrentItem(item) {
            console.log("createCurrentItem", item);

            if (item) {
                item.isSelected = true;

                item.analysis.content.story.paragraph =
                    item.analysis.content.story.paragraph.filter((el) => {
                        return (
                            el["#text"] &&
                            (!el["@attributes"] ||
                                el["@attributes"].type != "disclaimer")
                        );
                    });
                return item;
            } else {
                return {};
            }
        },
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ])
    },
}
</script>
<style scoped>
    @charset "UTF-8";
.home {
  font-family: "Source Han Sans CN";
}
.flex-right {
  display: flex;
  justify-content: flex-end;
}
.section-1 {
  position: relative;
  background: radial-gradient(
    129.79% 85.82% at 66.66% 87.6%,
    #0a0000 0%,
    #000 100%
  );
}

.section-1-box {
  position: relative;
  width: 100%;
  min-height: 661px;
  background: url(../assets/image/trading_central/bg_1.png);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
}
.section-1-box .content {
  position: relative;
  color: #fff;
  margin: 0 auto;
  padding: 100px 200px;
  max-width: 1440px;
  flex: 1;
}
.section-1-box .content .title {
  max-width: 616px;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.en .section-1-box .content .title {
  font-size: 37px;
}
.section-1-box .content .title > br {
  display: none;
}
.section-1-box .content .sub-title {
  margin-top: 8px;
  max-width: 530px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  font-style: normal;
  font-weight: 350;
  line-height: 150%;
}
.section-1-box .content .list {
  margin-top: 28px;
}
.section-1-box .content .list .item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.section-1-box .content .list .item .icon-Vector {
  margin-right: 15px;
  font-size: 15px;
}
.section-1-box .content .bg {
  display: block;
  position: absolute;
  right: 67px;
  top: 85px;
  width: 722px;
}
.ar .section-1-box .content .bg {
  left: 67px;
  right: auto;
}
.section-1-box .content .bg-m {
  display: none;
}
.section-1 .tips {
  /* max-width: 1440px; */
  padding: 0 200px;
  width: 100%;
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
  font-style: normal;
  font-weight: 350;
  line-height: 150%;
  position: absolute;
  bottom: 28px;
  text-align: center;
  /* left: 50%;
  transform: translate(-50%,0); */
}
.register {
  display: inline-flex;
  justify-content: center;
  min-width: 180px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #fff;
  color: #3d0101;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 28px;
  transition: all 0.2s;
}
.register .icon-chevron-right {
  font-size: 24px;
}

.register:hover {
  background-color: #3d0101;
  color: #fff;
}
.btn {
  display: flex;
  justify-content: center;
  /* width: 180px; */
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #fff;
  color: #3d0101;
  border-radius: 4px;
  border: 1px solid #3d0101;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 28px;
  transition: all 0.2s;
}

.btn[type="blank"] {
  display: inline-flex;
  justify-content: center;
  min-width: 180px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  background: #5d0101;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-top: 28px;
  transition: all 0.2s;
}

.btn[type="blank"] .icon-chevron-right {
  font-size: 24px;
}

.btn[type="blank"]:hover {
  background-color: #410101;
  color: #fff;
}

.section-box {
  margin: 0 auto;
  max-width: 1440px;
  padding: 44px 200px 74px;
}
.section-box .title {
  color: #333;
  text-align: center;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
.en .section-box .title {
  font-size: 42px;
}
.section-box .sub-title {
  color: #666;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 350;
  line-height: 150%;
  margin-top: 16px;
  padding: 0 80px;
}
.en .section-box .sub-title {
  font-size: 16px;
}

.kr .section-box .sub-title {
  font-weight: 400;
}
.jp .section-box .sub-title {
  font-weight: 500;
}
.section-box .content {
  margin-top: 40px;
  display: flex;
  column-gap: 80px;
  row-gap: 40px;
  padding: 40px 0;
}
.section-box .content .left {
  flex-shrink: 0;
  width: 524px;
  max-width: 50%;
}
.section-box .content .left img {
  width: 100%;
  height: auto;
}
.section-box .content .right .item {
  display: flex;
  justify-content: baseline;
}
.section-box .content .right .item .icon {
  font-size: 18px;
  color: #af8147;
  margin-right: 16px;
  margin-top: 3px;
  flex-shrink: 0;
}
.section-box .content .right .item .label {
  color: #666;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
.section-box .content .right .item .value {
  margin-top: 8px;
  color: #666;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.section-box .content .right .item + .item {
  margin-top: 28px;
}
.section-box .tips {
  color: #949699;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  text-align: center;
}
#app {
  position: relative;
  font-size: 12px;
  margin: 0 auto;
  width: 100%;
}
.mobile-item {
  display: none;
}
#app .nav-list {
  display: flex;
  margin-bottom: 20px;
}
#app .nav-list .nav-item {
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 13px 20px;
  border-bottom: 2px solid transparent;
  transition: background 0.2s;
  background: rgba(0, 0, 0, 0);
}
#app .nav-list .nav-item:hover {
  background: rgba(0, 0, 0, 0.03);
}
#app .nav-list .active {
  color: #3f62ec;
  border-bottom: 2px solid #3f62ec;
}

#app .data-content {
  display: flex;
  height: 500px;
  gap: 32px;
  padding-block: 8px;
}
#app .data-content .data-left {
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
#app .data-content .data-left .data-item {
  padding: 10px;
  margin-bottom: 2px;
}
#app .data-content .data-left .data-item:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

#app .data-content .data-left .isSelected {
  background-color: #ebebeb;
}
#app .data-content .data-left .data-name {
  font-size: 16rem;
  color: #333333;
}
#app .data-content .data-left .data-time {
  color: #5c5c5c;
  font-weight: 500;
  font-size: 0.75rem;
  white-space: nowrap;
  text-transform: uppercase;
  padding-top: 3px;
  padding-left: 15px;
}

#app .data-content .data-left .data-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 2px 0;
  color: #333333;
}
#app .data-content .data-left .data-title .icon-up {
  transform: rotate(90deg);
}

#app .data-content .data-left .up {
  color: #12823e;
}
#app .data-content .data-left .up .icon-up {
  transform: rotate(0);
}

#app .data-content .data-left .down {
  color: #d10000;
}
#app .data-content .data-left .down .icon-up {
  transform: rotate(180deg);
}

#app .data-content .data-left .icon-up {
  font-size: 20px;
  margin-right: 4px;
}

#app .data-content .data-left .data-summary {
  font-size: 14px;
  color: #333333;
  line-height: 120%;
}

#app .data-content .data-right {
  width: 35%;
  height: 100%;
  overflow-y: auto;
}

#app .data-content .info-list {
  margin-top: 18px;
}

#app .data-content .info-paragraph > div {
  margin-bottom: 12px;
  font-size: 14px;
  color: #333333;
}
#app .data-content .info-paragraph .label {
  font-weight: 600;
}

#app .loading-box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
}

#app .loading-box .icon-loading {
  font-size: 28px;
  color: #3d0101;
  animation: spin 2s linear infinite;
}
.fade-enter-active {
  transition: opacity 0.72s;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#TCIframe {
  width: 100%;
  /* padding-top: 40px; */
  /* height: 1500px; */
  height: 700px;
  border: none;
  margin: 0 -13px;
}
@media (min-width: 996px) {
  /* 滚动条轨道样式 */
  .scrollbar-container::-webkit-scrollbar {
    width: 8px; /* 设置滚动条宽度 */
  }

  /* 滚动条滑块样式 */
  .scrollbar-container::-webkit-scrollbar-thumb {
    background-color: #e6e6e6; /* 设置滑块背景颜色 */
    /* border-radius: 2px; 设置滑块圆角 */
  }

  /* 滚动条轨道hover状态样式 */
  .scrollbar-container::-webkit-scrollbar-track:hover {
    background-color: #f1f1f1; /* 设置轨道hover状态时的背景颜色 */
  }

  /* 滚动条滑块hover状态样式 */
  .scrollbar-container::-webkit-scrollbar-thumb:hover {
    background-color: #d5d5d5; /* 设置滑块hover状态时的背景颜色 */
  }
}
@media (max-width: 1440px) {
  .section-1-box .content {
    padding: 100px 140px;
  }
  .section-1-box .content .bg {
    right: 17px;
  }
  .ar .section-1-box .content .bg {
    left: 17px;
    right: auto;
  }
}
@media (max-width: 1300px) {
  .section-1-box .content {
    padding: 100px 100px;
  }

  .section-1-box .content .bg {
    width: 650px;
    top: 100px;
    right: 0;
  }
  .ar .section-1-box .content .bg {
    right: auto;
    left: 0;
  }
  .en .section-1-box .content .bg {
    top: 120px;
  }
  .section-1-box .content .sub-title {
    max-width: 450px;
  }
  .section-1-box .content .list {
    max-width: 450px;
  }
}
@media (max-width: 1100px) {
  .section-1-box .content .bg {
    width: 600px;
    top: 100px;
  }
  .en .section-1-box .content .bg {
    top: 160px;
    width: 550px;
  }
}
@media (max-width: 996px) {
  .mobile-item {
    padding: 18px 10px;
    display: block;
  }
  .market-analysis-1 {
    height: 190px;
    padding-top: 106px;
  }
  .market-analysis-1 .p1 {
    color: #fff;
    text-align: center;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    margin-top: 0px;
  }

  .section-1-box {
    background: url(../assets/image/trading_central/bg_1_m.png);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
  }

  .section-1-box .content {
    padding: 105px 20px;
    width: 100%;
  }
  .en .section-1-box .content {
    padding: 105px 20px 130px;
  }

  .section-1-box .content .bg {
    display: none;
  }
  .section-1-box .content .bg-m {
    display: block;
    width: 100%;
    height: auto;
  }

  .section-1-box .content .title {
    text-align: center;
    margin: 5px auto 0;
    font-size: 36px;
    line-height: 140%;
  }
  .en .section-1-box .content .title {
    font-size: 36px;
  }
  .section-1-box .content .title > br {
    display: block;
  }
  .section-1-box .content .sub-title {
    padding: 0 8px;
    max-width: none;
  }

  .section-1-box .content .list .item {
    padding: 6px 8px;
    font-size: 17px;
  }

  .section-1-box .content .list .item .icon-Vector {
    margin-right: 7px;
    font-size: 13px;
  }
  .register {
    display: flex;
    width: auto;
    max-width: 274px;
    margin: 38px auto 0;
  }
  .en .register {
    font-size: 14px;
  }
  .btn[type="blank"] {
    display: flex;
    width: auto;
    max-width: 274px;
    margin: 38px auto 0;
  }
  .en .btn {
    font-size: 14px;
  }
  .section-1 .tips {
    font-size: 10px;
    padding: 0 28px;
  }

  #app {
    margin: 0;
    padding: 0 8px;
  }

  #app .data-content {
    height: auto;
    flex-direction: column;
  }
  #app .data-content .data-left {
    /* order: 2;
    max-height: 500px;
    overflow-y: auto; */
  }
  #app .data-content .data-right {
    display: none;
    /* order: 1;
    width: 100%;
    max-height: 500px;
    overflow-y: auto; */
  }
  .section-box .tips {
    margin-top: 40px;
  }

  .section-box {
    margin: 80px auto;
    padding: 0 20px;
  }

  .section-box .title {
    font-size: 40px;
    padding: 0 8px;
  }

  .section-box .sub-title {
    margin-top: 26px;
    padding: 0 8px;
  }
  .section-box .content {
    padding: 0;
    margin-top: 42px;
  }

  .section-box .content .left {
    margin: 0 auto;
    max-width: none;
    width: 100%;
  }

  .section-box .content .right {
    padding: 0 8px;
  }

  .section-box .content .right .item .value {
    margin-top: 14px;
  }

  .section-box .content {
    flex-direction: column;
  }
}

.contentBox a:hover{
  color: var(--ebc-neutral-bg_a);
}
.contentBox{
  max-width: 1200rem;
  margin-inline: auto;
}
.BuzzFloatTab{
  padding:15rem 0;
  gap: 12rem;
  color: var(--ebc-text-tertiary);
  background: var(--ebc-neutral-bg_a);
  position: sticky;
  top: 80px;
  z-index: 2;
}
.BuzzFloatTab a{
  color: var(--ebc-text-tertiary)!important;
}
.BuzzFloatTab .tabSplit{
  flex: 0 0 24rem;
  width: 24rem;
  height: 1px;
  background:rgba(0, 0, 0, 0.28);
  display: none;
}
.BuzzFloatTab .tabWord{
  padding: 6rem 20rem;
  cursor: pointer;
}
.BuzzFloatTab .tabWord.active{
  border-radius: var(--ebc-corner-radius-rc24);
  background: var(--ebc-neutral-bg_c);
  color: var(--ebc-text-primary)!important;
  font-weight: 500;
}
.mBuzz {
  padding: 48rem 0 120rem;
  background: var(--ebc-neutral-bg_a);
}
.mBuzz .sub-title{
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.mBuzz .mBuzzIframe{
  width: 1196rem;
  display: block;
  margin-inline: auto;
  border-radius: 8px;
  border: 8px solid rgba(0, 0, 0, 0.12);
  height: 800px;
  padding-block: 8px;

}
.BuzzHeader{
  padding: 0px 24rem 24rem;
  position: relative;
  overflow: hidden;
}
.BuzzHeader .BuzzBg{
  width: calc(100% - 48rem);
  height: calc(100% - 24rem);
  border-radius: 12px;
  position: absolute;
  left: 24rem;
  right: 24rem;
}
.BuzzHeaderContainer{
  padding-top: 80rem;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  z-index: 3;
}
.BuzzHeaderLogo{
  width: 222rem;
  height: auto;
}
.BuzzHeader .shadowContainer{
  background: linear-gradient(180deg, rgba(1, 6, 21, 0.00) 0%, #010615 100%);
  width: 100%;
  height: 307rem;
  position: absolute;
  z-index: 2;
  bottom: 0;
  padding: 167rem 0 24rem;
}
.BuzzHeader .shadowContainer .BuzzHeaderBtn{
  width: fit-content;
  min-width: 180rem;
  margin-inline: auto;
  line-height: 48rem;
  gap: 5rem;
}
.BuzzHeader .shadowContainer .BuzzHeaderBtn:hover{
  color: var(--ebc-text-primary_white);
}
.BuzzHeader .shadowContainer .BuzzHeaderFooter{
  color: var(--ebc-text-secondary_white);
  margin-top: 48rem;
  max-width: 1200rem;
  margin-inline:auto;
}
.BuzzHeader h1{
  color: var(--ebc-text-primary_white);
  margin-top: 24rem;
}
.BuzzHeader h2{
  color: var(--ebc-text-secondary_white);
  margin: 24rem 0 25rem;
  max-width: 1200rem;
  margin-inline:auto;
}
.BuzzHeader .BuzzModel{
  width: 1108rem;
  height: auto;
  margin-inline: auto;
}
@media (max-width: 996px) {
  .BuzzHeader{
    padding: 0 0 328rem;
    max-height: 1667px;
    overflow: hidden;
    background: url('../assets/image/trading_central/section1BgM.png') 100% 100%;
  }
  .BuzzHeaderContainer{
    padding: 64rem 0 0;
    overflow: visible;
  }
  .BuzzHeaderLogo{
    width: 300rem;height: auto;
  }
  .BuzzHeader h1{
    margin-top: 16rem;
    padding-inline: 32rem;
  }
  .BuzzHeader h2{
    margin: 16rem 0 55rem;
    padding-inline: 32rem;
  }
  .BuzzHeader .BuzzModel{
    width: calc(100% - 64rem);
    height: 844rem;
    object-fit: cover;
    object-position: top center;
  }
  .shadowContainer{
    background: linear-gradient(180deg, rgba(1, 6, 21, 0.00) 0%, #010615 52.27%);
    padding: 248rem 32rem 64rem!important;
    z-index: 4;
    height: auto!important;
    min-height: 624rem!important;
    bottom: -328rem!important;
    
  }
  .BuzzHeader .shadowContainer .BuzzHeaderBtn{
    width: 100%;
    gap: 10rem;
  }
  .BuzzHeader .BuzzBg{
    border-radius: 0;
    height: 834px;
    width: auto;
    max-width: unset;
    left: -1186rem;
  }
  .BuzzFloatTab{
  padding:32rem;
  top: 44px;
  overflow: auto;
  max-width: 100%;
  justify-content: flex-start!important;

}
.BuzzFloatTab .tabWord{
  padding: 8rem 16rem;
}
.BuzzFloatTab .tabWord.active{
  border-radius: 24px;
}
.BuzzFloatTab .tabSplit{
flex: 0 0 48rem;
}
  .BuzzFloatTab::-webkit-scrollbar{
    display: none;
  }
  .BuzzFloatTab .tabWord{
    white-space: nowrap;
  }
.mBuzz .sub-title{
  margin-bottom: 80rem;
}
.mBuzz .mBuzzIframe{
  width: 686rem;
  height: 600px;
  padding-block: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
}
.analystViews{
  background: var(--ebc-neutral-bg_b);
  padding: 120rem 0;
  position: relative;
}
.mBuzz {
  position: relative;
}
.mBuzz .mbuzzContentShadow,
.analystViews .appContentShadow{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 370rem 0 118rem;
  background: linear-gradient(180deg, rgba(247, 247, 247, 0.00) 0%, #F7F7F7 76.71%);
}
.mBuzz .mbuzzContentShadow{
  background: linear-gradient(180deg, rgba(247, 247, 247, 0.00) 0%, rgba(247, 247, 247, 0.90) 35%, #F7F7F7 76.71%);

  padding: 500rem 0 300rem;

}
.mBuzz .mbuzzContentShadow a,
.analystViews .appContentShadow a{
  margin-inline: auto;
  width: fit-content;
  min-width: 180rem;
  gap: 5rem;
}
.mBuzz .mbuzzContentShadow a:hover,
.analystViews .appContentShadow a:hover{
  color: var(--ebc-text-primary_white);
}

@media (min-width: 996px) {
  .economicCalendar .contentBox,
  .analystViews .contentBox{
    max-width: 1196rem;
  }
  .navigate-wrapper{
    background: #fff!important;
    position: sticky!important;

  }
  .analystViews .data-content{
    border: 8px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background-color: #fff;
  }
  .analystViews .sub-title{
    color: var(--ebc-text-secondary);
    margin: 16rem 0 60rem;
  }
   .analystViews #app  .nav-list{
    justify-content: center;
    gap: 4rem;
    padding: 4rem;
    background-color: #fff;
    border-radius: var(--ebc-corner-radius-full);
    width: fit-content;
    margin-inline:auto;
   }
  .analystViews #app  .nav-list .nav-item{
    padding: 12rem;
    min-width: 142rem;
    font-size: 16rem;
    font-weight: 400;
    height: 48rem;
    line-height: 24rem;
    text-align: center;
    cursor: pointer;
  }
  .analystViews #app  .nav-list .nav-item:hover{
    background: transparent;
  }
  .analystViews #app  .nav-list .nav-item.active{
    background: var(--ebc-basecolor-active-500);
    border-radius: var(--ebc-corner-radius-full);
    color: #fff;
    font-weight: 500;
    border: 0;
  }
  .analystViews .nav-list{
    margin-bottom: 40rem!important;
  }
}
@media (max-width: 996px) {
.analystViews{
padding: 0 0 160rem;
background-color: #fff;
}
.analystViews .mobile-item{
  padding: 0;
  
}
.analystViews .info-list{
  background: var(--ebc-neutral-bg_a);
  margin-top: 0!important;
  padding: 18rem 0;
}
.analystViews .flex-right .btn{
  border: 0;
  margin: 16rem auto;
  gap:5rem;
  color: var(--ebc-basecolor-active-500);
  background: transparent;
  padding: 0;
}
.analystViews .flex-right {
  background-color: var(--ebc-neutral-bg_a)!important;
}
    .analystViews .flex-right .btn .iconfont{
      transform: rotate(-90deg);
      margin-left: 8rem;
    }
.analystViews .data-left .data-item{
  background-color: #fff;
}
.analystViews .data-left .isSelected{
  margin-bottom: 32rem!important;
}
.mBuzz .mbuzzContentShadow,
.analystViews .appContentShadow{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 160rem;
  padding: 600rem 0 250rem;
  background: linear-gradient(180deg, rgba(247, 247, 247, 0.0) 0%, rgba(247, 247, 247, 0.95)  40.71%,rgba(247, 247, 247, 1) 100%);
}
.mBuzz .mbuzzContentShadow{
  bottom: 58rem;
  padding: 500px 0 100px;
  background: linear-gradient(180deg, rgba(247, 247, 247, 0.0) 0%, rgba(247, 247, 247, 0.95)  70.71%,rgba(247, 247, 247, 1) 100%);

}
.mBuzz .mbuzzContentShadow a,
.analystViews .appContentShadow a{
  margin-inline: auto;
  width: fit-content;
  min-width: 180rem;
  height: 80rem;
  font-size: 28rem;
  gap: 5rem;
}
.analystViews .sub-title {
  margin:16rem 0 80rem;
  color: var(--ebc-text-secondary);
}
.analystViews #app .nav-list{
  gap: 16rem;
  margin-bottom: 48rem;
  padding-inline: 32rem;
  overflow: auto;
}
.analystViews #app .nav-list::-webkit-scrollbar{
  display: none!important;
}
#app {
  padding: 0!important;
}
.analystViews #app .nav-list .nav-item{
  background-color: #fff;
  padding: 16rem 32rem;
  font-size: 28rem;
  font-weight: 400;
  color: var(--ebc-text-secondary);
  line-height: 40rem;
  border-radius: var(--ebc-corner-radius-full);
  height: 72rem;
  white-space: nowrap;
}
.analystViews #app .nav-list .nav-item.active{
  background-color: var(--ebc-basecolor-active-500);
  color: var(--ebc-neutral-bg_a);
  border:0
}
}


.economicCalendar{
  padding: 120rem 0;
}
.economicCalendar .content{
  padding: 0;
  margin-top: 60rem;
}
.economicCalendar #TCIframe{
  border: 8px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
}
.economicCalendar .sub-title{
    margin-top: 16rem;
    color: var(--ebc-text-secondary);
  }
.techIndicator{
  background: var(--ebc-neutral-bg_b);
  padding: 120rem 0;;
}

.techIndicatorDesc{
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.techIndicator .model{
  width: 612rem;
  height: auto;
}
.techIndicator .wordList{
  flex: 0 0 510rem;
}
.techIndicator .wordList .wordItem{
  padding: 16rem 24rem;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_a);
}
.techIndicator .wordList .wordItem:nth-child(n+2){
  margin-top: 24rem;
}
.techIndicator .wordList .bottomDesc{
  margin-top: 4rem;
  color: var(--ebc-text-secondary);
}
.techIndicatorBtn{
  margin: 60rem auto 0;
  gap: 5rem;
  width: fit-content;
  min-width: 180rem;
  line-height: 48rem;
}
.techIndicatorBtn img{
  width: 24rem;
  height: 24rem;
}
@media (max-width: 996px) {
    .economicCalendar #TCIframe  {
    /* padding-top: 30px; */
    height: 120vh;
    margin: 0 auto;
    padding-block: 8px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
  }
  .economicCalendar{
    padding: 160rem 0;
  }
  .economicCalendar .content{
  padding: 0;
  margin-top: 80rem;
}
  
.techIndicator{
padding: 160rem 0;
}
.techIndicatorDesc{
margin-bottom: 80rem;
}
.techIndicatorIntro{
  flex-direction: column;
}
.techIndicator .wordList{
  order:2;
  flex: 1;
  margin-top: 48rem;
}
.techIndicator .model{
  width: 100%;
}
.techIndicator .techIndicatorBtn{
  height: 80rem;
  gap: 8rem;
  font-size: 14px;
  margin-top: 80rem;
}
.techIndicator .wordList .wordItem:nth-child(n+2){
  margin-top: 32rem;
}
.techIndicatorBtn img{
  width: 48rem;
  height: 48rem;
}
.techIndicator .wordList .wordItem{
padding: 32rem;
border-radius: 8px;
}
.techIndicator .wordList .bottomDesc{
margin-top: 8rem;
}
}

.MPTech{
  background: var(--ebc-neutral-bg-a);
  padding: 120rem 0;
}
.MPTechDesc{
  margin: 16rem 0 60rem;
  color: var(--ebc-text-secondary);
}
.MPTechBtn{
  margin-inline:auto;
  width: fit-content;
  min-width: 180rem;
}
.MPTechModel{
  width: 612rem;
  height: auto;
}
.MPTechContent{
  margin-bottom: 60rem;
}
.MPTechAdvanList{
  flex: 0 0 510rem;
}
.MPTechAdvanList .MPTechAdvan:nth-child(n+2){
  margin-top: 24rem;
}
.MPTechAdvan{
  padding: 16rem 24rem;
  border-radius: var(--ebc-corner-radius-rc08);
  background: var(--ebc-neutral-bg_b);
}
.MPTechAdvanDesc{
  margin-top: 4rem;
  color: var(--ebc-text-secondary);
}
@media (max-width: 996px) {
  .contentBox{
    padding-inline: 32rem;
  }
  .MPTech{
    padding: 160rem 0;
  }
.MPTechDesc{
margin-bottom: 80rem;
}
.MPTech .MPTechBtn{
  min-width: 208rem;
  height: 80rem;
  font-size: 28rem;
}
.MPTechModel{
  width: 552rem;
  height: auto;
}
.MPTechContent{
  margin-bottom: 80rem;
  flex-direction: column;
}
.MPTechAdvanList {
  margin-top: 30rem;
}
.MPTechAdvan{
  border-radius: 8px;
  padding: 32rem;
}
.MPTechAdvanList .MPTechAdvan:nth-child(n+2){
  margin-top: 32rem;
}
.MPTechAdvanDesc{
  margin-top: 8rem;
}
}
</style>